const _env = process.env;

export const NODE_ENV = _env.NODE_ENV;
export const BASE_URL = _env.BASE_URL;

const rawApiUrl = _env.VUE_APP_URL_API || '';

if (!rawApiUrl && _env.NODE_ENV !== 'test') {
  console.error(
    '[config] VUE_APP_URL_API is not defined. Check your .env file for the current build mode.'
  );
} else if (rawApiUrl && !/^https?:\/\//i.test(rawApiUrl)) {
  console.error(
    `[config] VUE_APP_URL_API ("${rawApiUrl}") is missing the https:// protocol. Requests will fail.`
  );
}

export const API = {
  BASE_URL: rawApiUrl && /^https?:\/\//i.test(rawApiUrl) ? rawApiUrl : '',
  TIMEOUT: 30000,
};
